import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
} from "@pushpress/pushpress-ui";
import { Link } from "react-router-dom";

interface UpgradeDialogParams {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const UpgradeDialog = ({
  isOpen,
  onOpenChange,
}: UpgradeDialogParams) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="tw-z-[999]">
        <div className="tw-flex tw-flex-col tw-space-y-2 tw-mb-4">
          <div className="tw-text-neutral-600 tw-text-sm">
            You are currently on PushPress Free.
          </div>
          <div className="tw-text-neutral-800">
            This feature is only available on the PushPress Pro and PushPress
            Max plans.
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="tw-w-full">
            <Link
              to={"/account"}
              className="tw-text-current hover:tw-no-underline"
            >
              View upgrade options
            </Link>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
